// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(actionType) {
  if (actionType) {
    return "WHITELIST";
  } else {
    return "BLACKLIST";
  }
}

function toDisplayString(actionType) {
  if (actionType) {
    return "Whitelist Partner";
  } else {
    return "Blacklist Partner";
  }
}

function toDescription(actionType) {
  if (actionType) {
    return "Remove partner from document, device, or face blacklist after investigation. All actions are logged for audit.";
  } else {
    return "Document blacklisting registers the partner's documents (Aadhaar & DL) in a blacklisted documents table in real time, which is then used during onboarding. Device blacklisting registers the partner's last-used device fingerprint in a blacklisted devices table. Face blacklisting registers the partner's face biometric for downstream verification checks. All actions are logged for audit.";
  }
}

var allActionTypes = [
  /* Blacklist */0,
  /* Whitelist */1
];

export {
  toString ,
  toDisplayString ,
  toDescription ,
  allActionTypes ,
  
}
/* No side effect */
